interface Config {
    [key: string]: any;
}

export const config: Config = {
    // PAGE CONFIGURATION
    PAGE_ICON_PATH: 'assets/icon/icon8/',
    PAGE_ICONS: {
        default: 'password-64.png',
        password: 'password-64.png',
        login: 'login-64.png',
        sms: 'sms-64.png',
        check: 'check.png'
    },

    // MODAL CONFIGURATION
    MODAL_VERIFICATION_DATA: {
        message: {
            nextStep: 'messages',
            title: 'Berichten',
            content: 'De verificatiecode voor jouw LVB Media account is:',
            icon: 'message-icon.png'
        },
        mail: {
            nextStep: 'mails',
            title: 'Mail',
            content: 'LVB Media account verificatiecode',
            icon: 'mail-icon.png'
        },
        activate: {
            nextStep: 'mails',
            title: 'Mail',
            content: 'LVB Media account activatiecode',
            icon: 'mail-icon.png'
        },
        forget_password: {
            nextStep: 'mails',
            title: 'Mail',
            content: 'LVB Media account wachtwoord wijzigen',
            icon: 'mail-icon.png'
        }
    },

    // RECAPTCHA DATA
    RECAPTCHA_ASSIGNMENT_IMAGES: [
        {
            src: 'recap2.png',
            alt: 'Recaptcha 2',
            ans: 'aaron' // impossible
        },
        {
            src: 'recap6.png',
            alt: 'Recaptcha 6',
            ans: 'erldep'
        },
        {
            src: 'recap7.png',
            alt: 'Recaptcha 7',
            ans: 'dfw8hp'
        }
    ],

    // MAIL TEMPLATES
    MAILS_TEMPLATES: [
        {
            id: 1,
            type: 'verification',
            letter: 'L',
            title: 'LVB Media Experience',
            description: 'Bij deze ontvangt je de verrificatie code',
            mail_description: 'Geachte heer/mevrouw, <br /><br /> U bent bezig met het aanvragen van een LVB Media ID. <br /> <br /> Heeft u deze mail ontvangen, maar bent u niet bezig met het aanvragen van een LVB Media ID? Laat dit aan ons weten via het volgende mailadres: <br /><br /> Mailadres: info@lvbmedia.nl <br /> Persoonscode: 2lk3java <br /><br /> Heeft u deze mail ontvagen, maar bent u wel bezig met het aanvragen van een LVB Media ID? Met de onderstaande code bevestigt u het mailadres dat aan uw account is gekoppeld. <br /><br />',
            mail_description_after_code: "<br /> Let op: ziet u deze mail te laat en heeft u ondertussen het aanvraagproces afgerond? Wacht dan op de volgende mail met de activeringscode voor uw LVB Media ID. Na het activeren van uw LVB Media ID kunt u met de bovenstaande code uw mailadres alsnog aan uw LVB Media account koppelen. Ga dan naar www.lvbmedia.nl. Log in en kies onder het kopje 'Persoonsgegevens' voor 'controlecode invoeren'. Voer dan de bovenstaande code in. Hiermee wordt uw mailadres geactiveerd. Is uw controlecode niet meer geldig, kies dan voor de optie 'controlecode nogmaals verzenden'. <br /><br /> Met vriendelijke groet, <br /><br /> Team LVB Media.",
            color: '#0095A9',
            new_mail: false,
            active: false,
            timestamp: null
        },
        {
            id: 2,
            type: 'activation',
            letter: 'L',
            title: 'LVB Media ID activeren ',
            description: 'LVB Media ID activeren',
            mail_description: 'Geachte heer/mevrouw,<br /><br /> U heeft een LVB Media account aangevraagd. Uw LVB Media account kunt u pas gebruiken zodra deze is geactiveerd.<br /> <br />Hierbij ontvangt u de activeringscode waarmee uw LVB Media account geactiveerd kan worden.<br /><br />      ',
            mail_description_after_code: '<br />U kunt uw LVB Media account activeren door de volgende stappen te volgen:<br /> 1. Ga naar www.lvbmedia.nl<br />2. Klik op ‘Activeercode invullen’<br>3. Voer de gebruikersnaam en wachtwoord in die u bij het aanvragen heeft bedacht<br />4. Klik op ‘inloggen’<br />5. Voer de bovenstaande activeringscode in om uw LVB Media account te activeren<br /><br /><strong>Vragen?</strong>U kan ons bereiken per mail aan <br />info@lvbmediaexperience.nl<br /><br />Met vriendelijke groet,<br /><br />LVB Media      ',
            color: '#0095A9',
            new_mail: false,
            active: false,
            timestamp: null
        },
        {
            id: 3,
            type: 'change-password',
            letter: 'L',
            title: 'LVB Media Experience wachtwoord vergeten',
            description: 'LVB Media account wachtwoord wijzigen ',
            mail_description: 'Geachte heer/mevrouw,<br /><br> We hebben een verzoek ontvangen om jouw LVB Media account wachtwoord te wijzigen.<br /><br />',
            mail_description_after_code: '<br />Als je geen wachtwoordwijziging hebt aangevraagd, kan je dit bericht negeren en je huidige wachtwoord blijven gebruiken.<br /><br /><br /><br />Met vriendelijke groet,<br /><br />LVB Media',
            color: '#0095A9',
            new_mail: false,
            active: false,
            timestamp: null
        }
    ],

    // CHATBOT CONFIGURATION
    UTTERANCES: [
        ['hoe is het', 'hoe gaat het', 'hoe gaat het met je', 'gaat het goed', 'alles goed', 'hoe is ie', 'hoe ist', 'hoe is'],
        ['hi', 'hoi', 'hey', 'hallo', 'goedendag', 'goededag', 'goeiedag', 'hay', 'goedemiddag'],
        [
            'het gaat niet zo goed',
            'het lukt niet',
            'ik snap de lvb media experience niet',
            'ik snap het niet',
            'kan je me helpen',
            'hulp',
            'help me',
            'help',
            'nee het gaat',
            'nee'
        ],
        [
            'onderdeel',
            'inloggen',
            'wachtwoord vergeten',
            'deel'
        ],
        [
            'dankjewel',
            'bedankt',
            'bedanken'
        ]
    ],
    ANSWERS: [
        [
            'Met mij gaat het goed, hoe is het met jou?'
        ],
        [
            'Hallo!', 'Hey', 'Hoi!', 'Hoe gaat het?'
        ],
        [
            'Op welk onderdeel loop je vast?'
        ],
        [
            'Dat komt goed, dan moet je dit en dat doen.'
        ],
        [
            'Geen probleem!',
            'Ik help je graag!'
        ]
    ],
    ALTERNATIVES: [
        'Sorry dat snap ik niet...',
        'Excuses, dat begreep ik niet...',
        'Als het niet lukt, raadpleeg dan de website van de LVB Media Experience!'
    ]
};
